import Layout from "../views/layout/Layout";

export default {
    path: '/log',
    component: Layout,
    redirect: '/log/login',
    meta: {title: '日志管理', icon: 'el-icon-document'},
    children: [{
        path: 'login',
        name: 'login',
        component: () => import('@/views/log/login/index'),
        meta: {title: '登录日志', icon: 'product-cate'},
        auth: 'log:login'
    }, {
        path: 'oprea',
        name: 'oprea',
        component: () => import('@/views/log/oprea/index'),
        meta: {title: '操作日志', icon: 'product-cate'},
        auth: 'log:oprea'
    }]
}



// WEBPACK FOOTER //
// ./src/router/log.js